import React from 'react';
import '../css/driver-modal-mobile.css';
import IconContainer from './IconsContainer';
import { driversData } from '../assets/data/driversData';

interface DriverModalProps {
  driverIndex: number; // Index to determine which driver data to show
}

const DriverModalMobile: React.FC<DriverModalProps> = ({ driverIndex }) => {
  // Safely fetch the driver data
  const driver = driversData[driverIndex - 1]; // Adjust index for 1-based input

  // Handle cases where the driver data doesn't exist
  if (!driver) {
    return <div className='driver-modal'>Driver not found</div>;
  }

  // Function to handle the click based on the screen size
  const handleClick = () => {
    const isMobile = window.innerWidth < 460; // Check if the screen width is less than 460px

    if (isMobile) {
      // For mobile devices, initiate a phone call
      window.location.href = driver.mainLinkMobile;
    } else {
      // For desktop, open the URL in a new tab
      window.open(driver.mainLink, '_blank');
    }
  };

  return (
    <div className='driver-modal' onClick={handleClick}>
      <div className='driver-modal-title'>
        <picture>
                <source srcSet={driver.profilePicWebp} type="image/webp"  />
                <img src={driver.profilePicPng} alt={`Zdjęcie taksówkarza o imieniu ${driver.name}`} />
        </picture>
        <div className='driver-modal-title-text'>
          <h2>{driver.name}</h2>
          <h3>{driver.car}</h3>
        </div>
      </div>
      <div className='driver-modal-info-container'>
        <picture>
                <source srcSet={driver.carPicWebp} type="image/webp" />
                <img src={driver.carPicPng} alt={`Zdjęcie taksówkarza o imieniu ${driver.name}`} />
        </picture>
        
        <div className='driver-modal-info'>
          <div className='driver-modal-capacity'>
            <picture>
              <source srcSet={driver.personIconWebp} type="image/webp"/>
              <img src={driver.personIconPng} alt='Ikona ilości miejsc' />
            </picture>
            
            <p>{driver.capacity}</p>
          </div>
          <div className='driver-modal-contact'>
            <picture>
              <source srcSet={driver.phoneIconWebp} type="image/webp"/>
              <img src={driver.phoneIconPng} alt='Ikona telefonu' />
            </picture>
            
            <p>{driver.phone}</p>
          </div>
          <IconContainer imagePaths={driver.socialIcons} actions={driver.socialLinks}  />
        </div>
      </div>
    </div>
  );
};

export default DriverModalMobile;